import { stringify } from 'yaml';

import {
  EvictorAdvancedConfig,
  EvictorConfig,
} from '@cast/types-workload-eviction';
import { toNumOrUndefined } from '@cast/utils';

import { FormValues } from '../_types';

import { parseYamlToAdvancedConfig } from './parseYamlToAdvancedConfig';
import isNumber from 'lodash/isNumber';

const parseCycleInterval = (
  cycleInterval: EvictorConfig['cycleInterval']
): number | undefined => {
  if (!cycleInterval) {
    return undefined;
  }

  return toNumOrUndefined(cycleInterval.replace('s', ''));
};

const serializeCycleIntervalSecondsToDurationString = (
  cycleIntervalSeconds: number
): `${number}s` => {
  return `${cycleIntervalSeconds}s`;
};

export const mapConfigToFormValues = ({
  config,
  advancedConfig,
}: {
  config: EvictorConfig;
  advancedConfig: EvictorAdvancedConfig;
}): FormValues => {
  return {
    enabled: !!config.enabled,
    aggressiveMode: !!config.aggressiveMode,
    scopedMode: !!config.scopedMode,
    ignorePodDisruptionBudgets: !!config.ignorePodDisruptionBudgets,
    nodeGracePeriodMinutes: config.nodeGracePeriodMinutes,
    cycleIntervalSeconds: parseCycleInterval(config.cycleInterval),
    maxTargetNodesPerCycle: config.maxTargetNodesPerCycle,
    advancedEvictorConfig: stringify(advancedConfig),
  };
};

export const mapFormValuesToConfig = (
  formValues: FormValues
): { config: EvictorConfig; advancedConfig: EvictorAdvancedConfig } => {
  const parseResult = parseYamlToAdvancedConfig(
    formValues.advancedEvictorConfig
  );

  return {
    config: {
      enabled: formValues.enabled,
      aggressiveMode: formValues.aggressiveMode,
      scopedMode: formValues.scopedMode,
      ignorePodDisruptionBudgets: formValues.ignorePodDisruptionBudgets,
      nodeGracePeriodMinutes: formValues.nodeGracePeriodMinutes,
      cycleInterval: isNumber(formValues.cycleIntervalSeconds)
        ? serializeCycleIntervalSecondsToDurationString(
            formValues.cycleIntervalSeconds
          )
        : undefined,
      maxTargetNodesPerCycle: formValues.maxTargetNodesPerCycle,
    },
    advancedConfig: {
      evictionConfig: parseResult.success ? parseResult.value : [],
    },
  };
};
